module.exports = __webpack_public_path__ + "static/financial-manager-00b9977437dbbdd70c92e804af3d794f.svg";